import { z } from "zod";

const nodeInstanceIdentifier = z.object({
  type: z.literal("instance"),
  id: z.number(),
  typeId: z.string(),
  ancestorIds: z.array(z.number()).optional(),
});

const nodeCreatableIdentifier = z.object({
  type: z.literal("creatable"),
  typeId: z.string(),
  definitionId: z.string().optional(),
});

const nodeTemplateIdentifier = nodeCreatableIdentifier.merge(
  z.object({
    type: z.literal("template"),
    templateId: z.number(),
  }),
);

const nodeIdentifier = z.discriminatedUnion("type", [
  nodeInstanceIdentifier,
  nodeCreatableIdentifier,
  nodeTemplateIdentifier,
]);

export const draggableDataSchema = z.object({
  node: nodeIdentifier,
  title: z.any().optional(), // ReactNode
  inLayersPanel: z.boolean().optional(),
  hasChildren: z.boolean().optional(),
  useCustomDragOverlay: z.boolean().optional(),
  isAbsolutelyPositioned: z.boolean().optional(),
});
export type DraggableData = z.infer<typeof draggableDataSchema>;

export const droppableDataSchema = z.object({
  title: z.any().optional(), // ReactNode
  node: nodeInstanceIdentifier,
  inLayersPanel: z.boolean().optional(),
  hasChildren: z.boolean().optional(),
  orientation: z.enum(["horizontal", "vertical"]),
});
export type DroppableData = z.infer<typeof droppableDataSchema>;

export const collisionDataSchema = z.object({
  indicator: z.enum(["insertTop", "insertBottom", "insertLeft", "insertRight", "inside"]),
  element: z.unknown(),
});
export type CollisionData = z.infer<typeof collisionDataSchema>;
